export default __webpack_public_path__ + "static/media/locationPin.9eb85ce2.webp";